<script>
import baseEdit from "@/views/components/base/baseEdit.vue";
import config from "../../../../config";

export default {
  extends: baseEdit,
  components: {},
  props: {
    rows: {
      type: Object,
      value: "",
    },
  },
  data() {
    return {
      mname: "checkout",
      submitSelect: false,
      key: "id",
      url: {},
      items: [
        {
          label: "申请科室",
          name: "applyDeskId",
          value: "",
          type: "selectDesk",
          width: "400px",
          dropList: [],
          disabled: true,
          rules: [
            {
              required: true,
              message: "科室不能为空",
              trigger: "blur",
              type: "number",
            },
          ],
          selected: 0,
        },
        {
          label: "申请人",
          name: "applyUser",
          disabled: true,
          value: "",
          width: "400px",
          type: "input",
        },

        {
          label: "申请内容",
          name: "applyContent",
          value: "",
          type: "textarea",
          width: "400px",
          disabled: true,
        },
        {
          label: "任务单号",
          name: "applyNum",
          disabled: true,
          value: "",
          width: "400px",
          type: "input",
        },
        {
          label: "申请时间",
          disabled: true,
          name: "applyTime",
          value: "",
          type: "datetime",
        },

        {
          label: "申请文件",
          name: "applyFileUrl",
          value: "",
          type: "documents",
          desc: "",
          handleRemove: this.handleRemove,
        },
        // {
        //     label: "负责人",
        //     name: "finishId",
        //     value: "",
        //     type: "select",
        //     width: "400px",
        //     dropList: [],
        //     rules: [
        //         {
        //             required: true,
        //             message: "负责人不能为空",
        //             trigger: "blur",
        //             type: "number",
        //         },
        //     ],
        //
        // },
        {
          label: "紧急程度",
          name: "emergencyDegree",
          type: "select",
          disabled: true,
          width: "400px",
          value: 1,
          dropList: [
            {
              value: 1,
              name: "一般",
            },
            {
              value: 2,
              name: "较重",
            },
            {
              value: 3,
              name: "重要",
            },
            {
              value: 4,
              name: "特别严重",
            },
          ],
        },
        {
          label: "任务状态",
          name: "state",
          type: "select",
          width: "400px",
          value: "",
          dropList: [
            {
              value: 1,
              name: "未完成",
            },
            {
              value: 2,
              name: "已完成",
            },
          ],
          onChange: this.onisParent,
        },

        {
          label: "结果文件",
          name: "resultFileUrl",
          value: "",
          type: "documents",
          desc: "",
          handleRemove: this.handleRemove,
        },
        {
          label: "结果内容",
          name: "finishContent",
          value: "",
          type: "textarea",
          width: "400px",
        },
        { label: "备注", name: "remark", value: "", type: "textarea", width: "400px" },
      ],
      forms: {
        // applyContent:this.rows.applyContent,
        // applyFileUrl:config.IMAGE_HOST+this.rows.applyFileUrl,
        // finishId:this.rows.finishId,
        //
        // emergencyDegree:this.rows.emergencyDegree,
        // state:this.rows.state,
        // resultFileUrl:config.IMAGE_HOST+this.rows.resultFileUrl,
        // finishContent:this.rows.finishContent,
        // remark:this.rows.remark,
        id: this.rows.id,
      },
    };
  },
  created() {
    this.onisParent(this.rows.state);
    this.initData();
    this.loadLevelData();
  },
  mounted() {},
  methods: {
    loadLevelData() {
      // 通过pk查询字典数据
      let q = {};
      $utils.api.load(`/maintainer/maintainer/desk/list`, q).then((res) => {
        if (res && res.rows) {
          let ll = res.rows;
          let dropList = [];
          for (let index = 0; index < ll.length; index++) {
            const element = ll[index];
            let xx = {};
            xx.value = element.id;
            xx.name = element.deskName;
            xx.children = element.children || [];
            dropList.push(xx);
          }
          for (let index = 0; index < this.items.length; index++) {
            const element = this.items[index];
            if (element && element.name == "applyDeskId") {
              // this.items[index]['dropList'] = dropList
              this.items[index]["dropList"] = (
                this.items[index]["dropList"] || []
              ).concat(dropList);
            }
          }
        }
      });
    },
    initData() {
      // 加载详情数据
      let id = this.forms.id;
      $utils.api.load(`/maintainer/maintainer/task/${id}`, {}).then((res) => {
        if (res && res.data) {
          this.forms = res.data;
          if (res.data.state == 1) {
            this.submitSelect = false;
            this.items[this.getItemIndex("state")].disabled = false;
            this.items[this.getItemIndex("resultFileUrl")].disabled = false;
            this.items[this.getItemIndex("finishContent")].disabled = false;
            this.items[this.getItemIndex("remark")].disabled = false;
            this.onisParent(1);
          } else {
            this.submitSelect = true;
            this.items[this.getItemIndex("state")].disabled = true;
            this.items[this.getItemIndex("resultFileUrl")].disabled = true;
            this.items[this.getItemIndex("finishContent")].disabled = true;
            this.items[this.getItemIndex("remark")].disabled = true;
            this.onisParent(2);
          }
        }
      });
    },
    //1代表存在父级
    //0代表不存在父级
    onisParent(val) {
      if (val == 1) {
        this.items[this.getItemIndex("resultFileUrl")].type = "kong";
        this.items[this.getItemIndex("finishContent")].type = "kong";
      }
      if (val == 2) {
        this.items[this.getItemIndex("resultFileUrl")].type = "documents";
        this.items[this.getItemIndex("finishContent")].type = "textarea";
      }
    },
    async handleSubmit() {
      if (!this.action) {
        return true;
      }
      let q = this.forms;
      await this.$refs.form.validate((valid) => {
        if (valid) {
          this.sloading = true;
          $utils.api
            .load(`/maintainer/maintainer/task`, q, "PUT")
            .then((res) => {
              this.sloading = false;
              if (res.status) {
                $utils.toast.success("保存成功");
              }
              this.$Modal.remove();
              setTimeout(() => {
                $utils.url.go(0);
              }, 500);
            })
            .catch((e) => {
              this.sloading = false;
              $utils.toast.error("保存异常" + e.message);
              this.$Modal.remove();
              setTimeout(() => {
                $utils.url.go(0);
              }, 500);
            });
        }
      });
    },

    // //选择处理人下拉框
    // async loadAdminUserData() {
    //     // 通过pk查询字典数据
    //     let q = {};
    //     let res = await $utils.api.load("/maintainer/maintainer/maiUser/listPrincipal", q)
    //     if (res && res.rows) {
    //         let ll = res.rows;
    //         let dropList = [];
    //         for (let index = 0; index < ll.length; index++) {
    //             const element = ll[index];
    //             let xx = {};
    //             xx.value = element.id;
    //             xx.name = element.userName;
    //             dropList.push(xx);
    //         }
    //         for (let index = 0; index < this.items.length; index++) {
    //             const element = this.items[index];
    //             if (element && element.name == "finishId") {
    //                 this.items[index]["dropList"] = dropList;
    //             }
    //         }
    //     }
    // },
  },
};
</script>
